import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { DirectCharge } from './directCharge.model';

@Injectable({
  providedIn: 'root'
})
export class DirectChargeService {

  constructor(private http: HttpClient, private global: Globle) { }

  get(status: number, userLoginId: string) {
    return this.http.get<DirectCharge[]>(this.global.APIURLV2 + "directcharge/get?status=" + status +
      "&userLoginId=" + userLoginId);
  }

  updateNotSeen() {
    return this.http.put(this.global.APIURLV2 + "directcharge/updatenotseen", "");
  }

  updateStatus(obj: any) {
    return this.http.put(this.global.APIURLV2 + "directcharge/updatestatus", obj);
  }

  getNotSeenCount() {
    return this.http.get<number>(this.global.APIURLV2 + "directcharge/getnotseen");
  }
}
